import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-white-opacity-50",
    style: { "z-index": "9999" }
};
const _hoisted_2 = { class: "report-sell-container p-20 p-md-30" };
const _hoisted_3 = { class: "control-bar card border-0 shadow-sm mb-25 p-20" };
const _hoisted_4 = { class: "row align-items-center" };
const _hoisted_5 = { class: "col-md-2" };
const _hoisted_6 = { class: "form-label fw-bold text-muted x-small mb-1" };
const _hoisted_7 = { class: "col-md-7 d-flex align-items-end" };
const _hoisted_8 = { class: "flex-grow-1" };
const _hoisted_9 = { class: "d-flex align-items-center gap-2" };
const _hoisted_10 = {
    class: "d-flex align-items-center bg-light rounded px-2",
    style: { "height": "38px" }
};
const _hoisted_11 = { class: "d-flex gap-1 no-print" };
const _hoisted_12 = { class: "col-md-3 d-flex justify-content-end align-items-end gap-1" };
const _hoisted_13 = { class: "nav nav-pills nav-premium mb-25 gap-2 px-2 scroll-x no-print" };
const _hoisted_14 = { class: "nav-item" };
const _hoisted_15 = { class: "nav-item" };
const _hoisted_16 = { class: "nav-item" };
const _hoisted_17 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_18 = { class: "nav-item" };
const _hoisted_19 = { class: "nav-item" };
const _hoisted_20 = { class: "nav-item" };
const _hoisted_21 = { class: "tab-content" };
const _hoisted_22 = {
    key: 0,
    class: "tab-pane fade show active"
};
const _hoisted_23 = {
    key: 0,
    class: "analytics-grid"
};
const _hoisted_24 = { class: "row mb-25" };
const _hoisted_25 = { class: "col-lg-8" };
const _hoisted_26 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_27 = {
    key: 1,
    class: "text-center py-5 text-muted"
};
const _hoisted_28 = { class: "col-lg-4" };
const _hoisted_29 = {
    class: "card h-100 border-0 shadow-sm p-20 text-white",
    style: { "background-color": "#76d2e3" }
};
const _hoisted_30 = { class: "mt-4" };
const _hoisted_31 = { class: "fw-black" };
const _hoisted_32 = { class: "mt-4" };
const _hoisted_33 = { class: "fw-bold" };
const _hoisted_34 = { class: "mt-4" };
const _hoisted_35 = { class: "fw-bold" };
const _hoisted_36 = { class: "row mb-25" };
const _hoisted_37 = { class: "col-md-4" };
const _hoisted_38 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_39 = {
    key: 1,
    class: "text-center py-5 text-muted small"
};
const _hoisted_40 = { class: "col-md-8" };
const _hoisted_41 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_42 = {
    key: 1,
    class: "text-center py-5 text-muted small"
};
const _hoisted_43 = { class: "row mb-25" };
const _hoisted_44 = { class: "col-lg-6" };
const _hoisted_45 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_46 = { class: "table-responsive" };
const _hoisted_47 = { class: "table table-borderless align-middle" };
const _hoisted_48 = { class: "text-end fw-bold" };
const _hoisted_49 = { class: "text-end" };
const _hoisted_50 = { class: "col-lg-6" };
const _hoisted_51 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_52 = { class: "d-flex justify-content-around mt-4" };
const _hoisted_53 = { class: "text-center" };
const _hoisted_54 = { class: "attach-rate-circle mb-2" };
const _hoisted_55 = { class: "text-center" };
const _hoisted_56 = { class: "attach-rate-circle mb-2" };
const _hoisted_57 = {
    key: 1,
    class: "tab-pane fade show active"
};
const _hoisted_58 = {
    key: 2,
    class: "tab-pane fade show active"
};
const _hoisted_59 = {
    key: 3,
    class: "tab-pane fade show active"
};
const _hoisted_60 = {
    key: 4,
    class: "tab-pane fade show active"
};
const _hoisted_61 = { class: "row" };
const _hoisted_62 = { class: "col-lg-12 mb-4" };
const _hoisted_63 = { class: "col-lg-12" };
const _hoisted_64 = {
    key: 5,
    class: "tab-pane fade show active"
};
const _hoisted_65 = {
    key: 6,
    class: "tab-pane fade show active"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_v_select = _resolveComponent("v-select");
    const _component_apexchart = _resolveComponent("apexchart");
    const _component_VabeneAnalytiqueAvancee = _resolveComponent("VabeneAnalytiqueAvancee");
    const _component_VabeneTvaReport = _resolveComponent("VabeneTvaReport");
    const _component_VabeneDeletedOrdersReport = _resolveComponent("VabeneDeletedOrdersReport");
    const _component_VabeneTopProduitReportSell = _resolveComponent("VabeneTopProduitReportSell");
    const _component_VabeneNombreCommandeProductDate = _resolveComponent("VabeneNombreCommandeProductDate");
    const _component_VabeneTauxOrderCategorieDate = _resolveComponent("VabeneTauxOrderCategorieDate");
    const _component_VabeneAverageBasketStats = _resolveComponent("VabeneAverageBasketStats");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoaderComponent)
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('forms.filterByRestaurant')), 1),
                        _createVNode(_component_v_select, {
                            modelValue: _ctx.restaurantSelected,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.restaurantSelected) = $event)),
                            options: _ctx.originalRestaurant || [],
                            label: "name",
                            reduce: (r) => r.id,
                            class: "v-select-premium sm"
                        }, null, 8, ["modelValue", "options", "reduce"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label fw-bold text-muted x-small mb-1" }, "Période d'analyse", -1)),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("button", {
                                        class: "btn btn-icon-only btn-sm",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.changeDate(-1)))
                                    }, [...(_cache[17] || (_cache[17] = [
                                            _createElementVNode("i", { class: "ph-bold ph-caret-left" }, null, -1)
                                        ]))]),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "date",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.filters.startDate) = $event)),
                                        class: "form-control form-control-sm border-0 bg-transparent text-center fw-bold px-1",
                                        style: { "font-size": "0.8rem" },
                                        onChange: _cache[3] || (_cache[3] =
                                            //@ts-ignore
                                            (...args) => (_ctx.fetchAdvancedStats && _ctx.fetchAdvancedStats(...args)))
                                    }, null, 544), [
                                        [_vModelText, _ctx.filters.startDate]
                                    ]),
                                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mx-1 text-muted small" }, "à", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "date",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.filters.endDate) = $event)),
                                        class: "form-control form-control-sm border-0 bg-transparent text-center fw-bold px-1",
                                        style: { "font-size": "0.8rem" },
                                        onChange: _cache[5] || (_cache[5] =
                                            //@ts-ignore
                                            (...args) => (_ctx.fetchAdvancedStats && _ctx.fetchAdvancedStats(...args)))
                                    }, null, 544), [
                                        [_vModelText, _ctx.filters.endDate]
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-icon-only btn-sm",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.changeDate(1)))
                                    }, [...(_cache[18] || (_cache[18] = [
                                            _createElementVNode("i", { class: "ph-bold ph-caret-right" }, null, -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("button", {
                                        class: "btn btn-xs btn-outline-secondary py-1",
                                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.setQuickDate('today')))
                                    }, "Aujourd'hui"),
                                    _createElementVNode("button", {
                                        class: "btn btn-xs btn-outline-secondary py-1",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.setQuickDate('yesterday')))
                                    }, "Hier")
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-dark d-flex align-items-center gap-1",
                            onClick: _cache[9] || (_cache[9] =
                                //@ts-ignore
                                (...args) => (_ctx.exportGlobalCsv && _ctx.exportGlobalCsv(...args)))
                        }, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("i", { class: "ph-bold ph-download-simple" }, null, -1),
                                _createElementVNode("span", { class: "fw-bold" }, "Exporter", -1)
                            ]))])
                    ])
                ])
            ]),
            _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'dashboard' }]),
                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.handleTabChange('dashboard')))
                    }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("i", { class: "ph-bold ph-chart-line-up" }, null, -1)
                        ]))], 2)
                ]),
                _createElementVNode("li", _hoisted_15, [
                    _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'analytique' }]),
                        onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.handleTabChange('analytique')))
                    }, " Analytique ", 2)
                ]),
                _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'tva' }]),
                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.handleTabChange('tva')))
                    }, " TVA ", 2)
                ]),
                (_ctx.isFranchise)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                        _createElementVNode("button", {
                            class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'deleted' }]),
                            onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.handleTabChange('deleted')))
                        }, " Annulations ", 2)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_18, [
                    _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'products' }]),
                        onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.handleTabChange('products')))
                    }, " Produits ", 2)
                ]),
                _createElementVNode("li", _hoisted_19, [
                    _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'categories' }]),
                        onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.handleTabChange('categories')))
                    }, " Catégories ", 2)
                ]),
                _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'basket' }]),
                        onClick: _cache[16] || (_cache[16] = ($event) => (_ctx.handleTabChange('basket')))
                    }, " Panier ", 2)
                ])
            ]),
            _createElementVNode("div", _hoisted_21, [
                (_ctx.activeTab === 'dashboard')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_ctx.advancedData)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            _cache[23] || (_cache[23] = _createElementVNode("h5", { class: "fw-bold mb-20" }, "Ventes et Volume", -1)),
                                            (_ctx.series.sales?.[0]?.data?.length)
                                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                                    height: "350",
                                                    options: _ctx.chartOptions.sales,
                                                    series: _ctx.series.sales,
                                                    key: 'sales-' + _ctx.series.sales[0].data.length
                                                }, null, 8, ["options", "series"]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_27, "Aucune donnée de vente"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                            _cache[27] || (_cache[27] = _createElementVNode("h5", { class: "fw-bold mb-4 opacity-75" }, "Statistiques Clés", -1)),
                                            _createElementVNode("div", _hoisted_30, [
                                                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "small opacity-70 mb-0" }, "Total Ventes", -1)),
                                                _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.totalRevenue.toFixed(2)) + " CHF", 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "small opacity-70 mb-0" }, "Nombre de Commandes", -1)),
                                                _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.totalOrderCount), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "small opacity-70 mb-0" }, "Panier Moyen (AOV)", -1)),
                                                _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.averageBasket.toFixed(2)) + " CHF", 1)
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _cache[28] || (_cache[28] = _createElementVNode("h5", { class: "fw-bold mb-20" }, "Canaux de Vente", -1)),
                                            (_ctx.series.platforms?.length && _ctx.series.platforms.some(v => v > 0))
                                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                                    type: "donut",
                                                    height: "250",
                                                    options: _ctx.chartOptions.platforms,
                                                    series: _ctx.series.platforms,
                                                    key: 'platforms-' + _ctx.series.platforms.join('-')
                                                }, null, 8, ["options", "series"]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_39, "Aucun canal de vente"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _cache[29] || (_cache[29] = _createElementVNode("h5", { class: "fw-bold mb-20" }, "Heures de Pointe", -1)),
                                            (_ctx.series.peakHours?.[0]?.data?.length)
                                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                                    type: "bar",
                                                    height: "250",
                                                    options: _ctx.chartOptions.peakHours,
                                                    series: _ctx.series.peakHours,
                                                    key: 'peak-' + _ctx.series.peakHours[0].data.length
                                                }, null, 8, ["options", "series"]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_42, "Aucune donnée horaire"))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                            _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "fw-bold mb-20" }, "Top 5 Produits", -1)),
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("table", _hoisted_47, [
                                                    _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", { class: "text-muted small" }, [
                                                            _createElementVNode("th", null, "Produit"),
                                                            _createElementVNode("th", { class: "text-end" }, "Ventes"),
                                                            _createElementVNode("th", { class: "text-end" }, "CA")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topProducts, (p) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: p.name
                                                            }, [
                                                                _createElementVNode("td", null, _toDisplayString(p.name), 1),
                                                                _createElementVNode("td", _hoisted_48, _toDisplayString(p.count), 1),
                                                                _createElementVNode("td", _hoisted_49, _toDisplayString(p.revenue.toFixed(2)) + " CHF", 1)
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _cache[34] || (_cache[34] = _createElementVNode("h5", { class: "fw-bold mb-20" }, "Attach Rate (%)", -1)),
                                            _createElementVNode("div", _hoisted_52, [
                                                _createElementVNode("div", _hoisted_53, [
                                                    _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.advancedData.attachRate.drinks.toFixed(1)) + "%", 1),
                                                    _cache[32] || (_cache[32] = _createElementVNode("p", { class: "small text-muted" }, "Boissons", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_55, [
                                                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.advancedData.attachRate.desserts.toFixed(1)) + "%", 1),
                                                    _cache[33] || (_cache[33] = _createElementVNode("p", { class: "small text-muted" }, "Desserts", -1))
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.activeTab === 'analytique')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createVNode(_component_VabeneAnalytiqueAvancee, {
                            restaurantId: _ctx.restaurantSelected || 'all',
                            startDate: _ctx.filters.startDate,
                            endDate: _ctx.filters.endDate
                        }, null, 8, ["restaurantId", "startDate", "endDate"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.activeTab === 'tva')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createVNode(_component_VabeneTvaReport, {
                            restaurantId: _ctx.restaurantSelected || 'all',
                            startDate: _ctx.filters.startDate,
                            endDate: _ctx.filters.endDate
                        }, null, 8, ["restaurantId", "startDate", "endDate"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.activeTab === 'deleted')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createVNode(_component_VabeneDeletedOrdersReport, {
                            restaurantId: _ctx.restaurantSelected || 'all',
                            startDate: _ctx.filters.startDate,
                            endDate: _ctx.filters.endDate
                        }, null, 8, ["restaurantId", "startDate", "endDate"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.activeTab === 'products')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_VabeneTopProduitReportSell, {
                                    restaurantId: _ctx.restaurantSelected || 'all',
                                    startDate: _ctx.filters.startDate,
                                    endDate: _ctx.filters.endDate
                                }, null, 8, ["restaurantId", "startDate", "endDate"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                                _createVNode(_component_VabeneNombreCommandeProductDate, {
                                    restaurantId: _ctx.restaurantSelected || 'all',
                                    startDate: _ctx.filters.startDate,
                                    endDate: _ctx.filters.endDate
                                }, null, 8, ["restaurantId", "startDate", "endDate"])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.activeTab === 'categories')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _createVNode(_component_VabeneTauxOrderCategorieDate, {
                            restaurantId: _ctx.restaurantSelected || 'all',
                            startDate: _ctx.filters.startDate,
                            endDate: _ctx.filters.endDate
                        }, null, 8, ["restaurantId", "startDate", "endDate"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.activeTab === 'basket')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createVNode(_component_VabeneAverageBasketStats, {
                            restaurantId: _ctx.restaurantSelected || 'all',
                            startDate: _ctx.filters.startDate,
                            endDate: _ctx.filters.endDate
                        }, null, 8, ["restaurantId", "startDate", "endDate"])
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ], 64));
}
